import React from 'react';
import './index.scss';
import OptionalIcon from '../../atoms/Icon/OptionalIcon';

const SpInputLine = ({ title, children, optional = false }) =>{
  const DispTitle = () => {
    return Array.isArray(title) 
      ? title.map(line => (
        <span key={line} className="">
          {line}
          <br />
        </span>
      ))
      : <>{title}</>;
  };

  return (
    <div className="SpInputLine">
      <div className="PIA-title"> 
        <DispTitle />
        {optional && <OptionalIcon /> }
      </div>
      <div className="PIA-item">
        {children}
      </div>
    </div>
  );
};

export default SpInputLine;